import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { mapStateToPropsWrapper, verificationProps } from '../../CaptureErreurs';
import Card from '../../Card';


const CardChoixModePaiement = ({
    PrlOk, ModePrl, setChoix,
}) => (
    <Card Titre="Moyens de paiements à votre disposition" SousTitre="Cliquez sur le mode de paiement choisi">
        <div className="d-flex flex-column align-items-center">
            {PrlOk ?
                <React.Fragment>
                    <Link to={{ pathname: '/MesInformations/SaisieRIB', state: { TypePrelevement: 'Automatique' } }} className="btn btn-info mt-2" style={{ width: 250 }} hidden={!(ModePrl.AutoExigibilite || ModePrl.AutoMensuel)}>
                        Prélèvement automatique
                    </Link>
                    <Link to={{ pathname: '/MesInformations/SaisieRIB', state: { TypePrelevement: 'Manuelle' } }} className="btn btn-primary mt-2" style={{ width: 250 }} hidden={!ModePrl.ALaDemande} >
                        Prélèvement à la demande
                    </Link>
                </React.Fragment> : null}
            <button onClick={() => { setChoix('virement'); }} className="btn btn-secondary mt-2" style={{ width: 250 }}>
                Virement
            </button>
            <button onClick={() => { setChoix('cheque'); }} className="btn btn-secondary mt-2" style={{ width: 250 }}>
                Chèque
            </button>
        </div>
    </Card>
);
CardChoixModePaiement.displayName = 'CardChoixModePaiement';
CardChoixModePaiement.requiredProps = [
    'ModePrl', // Modes de prélèvement accepté par le syndic
    'PrlOk', // Prélévement activé par la copro ou non
];

function mapStateToProps({
    SynStore: {
        Syn: { ModePrl },
    },
    CopStore: {
        Cop: { PrlOk },
    },
}) {
    return { ModePrl, PrlOk };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardChoixModePaiement));



// WEBPACK FOOTER //
// ./src/components/MesInfos/Paiement/CardChoixModePaiement.js